exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".thumbs {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin: 5px auto;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n}\n.thumb {\n    width: 50px;\n    height: 50px;\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    margin-right: 5px;\n    -webkit-box-align: center;\n        -ms-flex-align: center;\n            align-items: center;\n    -webkit-box-pack: center;\n        -ms-flex-pack: center;\n            justify-content: center;\n    border: #e4e4e4 solid 1px;\n}\n.thumb.active {-webkit-box-shadow: 0 0 6px rgba(0,0,0,0.15);box-shadow: 0 0 6px rgba(0,0,0,0.15);}\n.thumb:last-child { margin-right: 0; }\n.thumb img { max-width: 100%; max-height: 100%; }\n.store-product-row {\n    display: -webkit-box;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-flow: wrap;\n        flex-flow: wrap;\n}\n.store-product {\n    height: calc(100% - 30px);\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/login.theprintlife.com/src/app/mnt-store-product/store-home/store-home.component.css
// module id = ../../../../../src/app/mnt-store-product/store-home/store-home.component.css
// module chunks = mnt-store-product.module